<div class="style2023 flex" style="margin-bottom: 18px; margin-top: 8px">
  <div
    style="
      display: inline-block;
      height: 18px;
      line-height: 18px;
      margin-right: 5px;
      font-weight: 600;
    "
    class="flex-shrink-1"
  >
    All Jobs
  </div>

  <div class="flex-grow-1">
    <div style="padding-left: 8px; padding-right: 8px">
      <div class="md-inputfield" style="position: relative; width: 240px">
        <input
          id="orgNameInput"
          #regInput
          autofocus
          (ngModelChange)="searchTextChanged($event)"
          [ngModel]="searchText"
          autocomplete="off"
          class="search-box"
          name="regInput"
          pInputText
          placeholder="Search Vehicle Reg."
          spellcheck="false"
          type="text"
        />
        <span class="fa fa-search search-icon"></span>

        <button
          pButton
          type="button"
          icon="fa ui-icon-restore"
          class="button-style btn-sm ui-tertiary-button ml-2"
          (click)="resetVrm()"
        ></button>
      </div>
    </div>
  </div>
</div>

<jobs-information-list
  [homePosition]="supplierHomePos"
  [jobs]="jobs"
  [busy]="isBusy"
  [noResultsText]="'Enter vehicle registration to search for jobs'"
></jobs-information-list>
